"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const react_2 = require("@osmosys/react");
exports.ContentSystemSettings = ({ integration }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysSmallContainer, null,
            react_1.default.createElement(reusables_1.Form, { mutationProps: {
                    mutation: graphql_1.updateContentSystem,
                    refetchQueries: [
                        {
                            query: graphql_1.integration,
                            variables: {
                                id: integration.id,
                            },
                        },
                    ],
                }, valuesToVariables: values => {
                    return {
                        data: {
                            name: values.name.trim(),
                        },
                        id: integration.id,
                    };
                }, formikProps: {
                    initialValues: {
                        name: integration.name || '',
                    },
                    validationSchema: Yup.object().shape({
                        name: Yup.string()
                            .trim()
                            .required('Required'),
                    }),
                }, showBottomToolbar: true }, () => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "Name", name: "name" })))))));
};
//# sourceMappingURL=ContentSystemSettings.js.map